module.exports = __webpack_public_path__ + "img/logo_wcaworld1.c1a41d1d.png";